import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w1200 clearfix eva-all-box" }
const _hoisted_2 = { class: "eva-all" }
const _hoisted_3 = { class: "section-list" }
const _hoisted_4 = { class: "valuationc" }
const _hoisted_5 = {
  id: "bjCount",
  class: "valuationcount"
}
const _hoisted_6 = { class: "valuationc" }
const _hoisted_7 = {
  id: "bjOnLineCount",
  class: "valuationcount"
}
const _hoisted_8 = { class: "valuationc" }
const _hoisted_9 = {
  id: "badCount",
  class: "valuationcount"
}
const _hoisted_10 = { class: "valuationc" }
const _hoisted_11 = {
  id: "rectifybadRate",
  class: "valuationcount"
}
const _hoisted_12 = {
  id: "bm_content",
  class: "focus",
  style: {"height":"236px","margin":"20px 0 6px","overflow":"hidden"}
}
const _hoisted_13 = {
  id: "table-one",
  class: "eva-all-evaluate"
}
const _hoisted_14 = {
  class: "evaluate-title",
  style: {"width":"100%","overflow":"hidden"}
}
const _hoisted_15 = {
  class: "readRate-blcok",
  style: {"width":"140px","float":"left"}
}
const _hoisted_16 = { class: "evaluate-list" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "w1200 clearfix" }
const _hoisted_20 = { class: "canal clearfix" }
const _hoisted_21 = { class: "clearfix" }
const _hoisted_22 = { class: "qd-number" }
const _hoisted_23 = { class: "qd-number" }
const _hoisted_24 = { class: "qd-number" }
const _hoisted_25 = { class: "qd-number" }
const _hoisted_26 = { class: "qd-number" }
const _hoisted_27 = { class: "qd-number" }
const _hoisted_28 = { class: "w1200 clearfix" }
const _hoisted_29 = {
  id: "deptAnalysis",
  class: "analysis-list"
}
const _hoisted_30 = ["title"]
const _hoisted_31 = { style: {"width":"16%","cursor":"text"} }
const _hoisted_32 = { style: {"width":"10%","cursor":"text"} }
const _hoisted_33 = { style: {"width":"10%","cursor":"text"} }
const _hoisted_34 = { style: {"width":"10%","cursor":"text"} }
const _hoisted_35 = { style: {"width":"10%","cursor":"text"} }
const _hoisted_36 = { style: {"width":"10%","cursor":"text"} }
const _hoisted_37 = { style: {"width":"10%","cursor":"text"} }

import { AREA_ID } from '@/config/const'
import { getEvaluteCount,getEvaluatePublic,getEvaluateFromCount,getEvaluateDepartmentCount } from '@/config/request'
import { reactive } from 'vue'
import { Vue3SeamlessScroll } from 'vue3-seamless-scroll'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const data = reactive({
    evaluateCount: [] as any,
    infoList: [] as any,
    evaluateFromCount: [] as any,
    bmbjsList: [] as any,
})
const getEvaluteCountData = async() => {
    let param = {
    }
    const res = await getEvaluteCount(param) as any
    if (res.success) {
        data.evaluateCount = res.result.records[0]
    }
    
}
const getEvaluatePublicData = async() => {
    let param = {
        pageNum:1,
        pageSize:1000
    }
    const res = await getEvaluatePublic(param) as any
    if (res.success) {
        data.infoList = res.result.records;
        data.infoList.forEach((item:any)=>{
            item.evaluatorPhone = doPhonePrivate(item.evaluatorPhone)
        })
    }
}
const getEvaluateFromCountData = async() => {
    let param = {
    }
    const res = await getEvaluateFromCount(param) as any
    if (res.success) {
        data.evaluateFromCount = res.result.records[0]
    }
}
const getEvaluateDepartmentCountData = async() => {
    let param = {
        areaCode: AREA_ID,
        pageNum:1,
        pageSize:1000
    }
    const res = await getEvaluateDepartmentCount(param) as any
    if (res.success) {
        data.bmbjsList = res.result.records;
        data.bmbjsList.forEach((item:any) => {
            item.rate = Number(( ((Number(item.notgoodCount) + Number(item.verynotgoodCount))/ item.total))*100).toFixed(3)
        })
    }
}
const doPhonePrivate = (s:any) => {
  let pho = /(\d{3})\d*(\d{4})/
  return s.replace(pho, '$1****$2')
}
const getRateName = (rate:any) => {
    let rateName = {"1": "非常不满意","2": "不满意","3": "一般","4": "满意","5": "非常满意"} as any
    return rateName[rate]
}
const init = () => {
    getEvaluteCountData()
    getEvaluatePublicData()
    getEvaluateFromCountData()
    getEvaluateDepartmentCountData()
}

init()

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[36] || (_cache[36] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", null, [
      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "clearfix eva-banner" }, [
        _createElementVNode("div", { class: "w1200 banner-box" }, [
          _createElementVNode("div", { class: "banner-left" }, [
            _createElementVNode("div", null, "好差评"),
            _createElementVNode("p", null, "建立政务服务“好差评”制度，服务绩效由企业和群众来评判，不断深化服务理念，"),
            _createElementVNode("p", null, "提升政务服务水平。")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "eva-all-top clearfix" }, [
            _createElementVNode("div", { class: "eva-all-top-box clearfix" }, [
              _createElementVNode("div", { style: {"font-size":"24px"} }, "中国（河南）自由贸易试验区开封片区")
            ])
          ], -1)),
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(data.evaluateCount.evaluteCount || 0), 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "valuationT" }, "件", -1))
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("p", null, "主动评价数", -1))
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString((data.evaluateCount.evaluteCount - data.evaluateCount.badEvalute) || 0), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "valuationT" }, "件", -1))
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("p", null, "好评数", -1))
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(data.evaluateCount.badEvalute || 0), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "valuationT" }, "条", -1))
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("p", null, "差评数", -1))
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString((data.evaluateCount.badEvalute/data.evaluateCount.evaluteCount) || 0) + "%", 1)
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("p", null, "差评率", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (data.infoList.length>0)
              ? (_openBlock(), _createBlock(_unref(Vue3SeamlessScroll), {
                  key: 0,
                  class: "seamless-warp1",
                  list: data.infoList
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.infoList, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("div", _hoisted_14, [
                            _cache[7] || (_cache[7] = _createElementVNode("img", {
                              src: "/images/hdp-icon.png",
                              class: "evaluate-hdp"
                            }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(item.name), 1),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_el_rate, {
                                modelValue: item.satisfactionEvaluate,
                                "onUpdate:modelValue": ($event: any) => ((item.satisfactionEvaluate) = $event),
                                disabled: "",
                                size: "large",
                                "text-color": "#ff9900"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("span", null, "整体服务：" + _toDisplayString(getRateName(item.satisfactionEvaluate)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            (item.serviceName !=null || item.serviceName != '')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_17, "评价事项：" + _toDisplayString(item.serviceName), 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_18, "事项部门：" + _toDisplayString(item.deptName), 1)),
                            _createElementVNode("span", null, "联系方式:" + _toDisplayString(item.evaluatorPhone) + "    评价时间：" + _toDisplayString(item.evaluateTime), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["list"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "tit" }, [
          _createElementVNode("h2", null, "本级各渠道评价总数"),
          _createElementVNode("div", { class: "title-num" }, "01")
        ], -1)),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("ul", _hoisted_21, [
            _createElementVNode("li", null, [
              _createElementVNode("div", null, [
                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "qd-type" }, "PC端", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "qd-name" }, "收到评价数", -1)),
                _cache[11] || (_cache[11] = _createTextVNode()),
                _createElementVNode("span", _hoisted_22, _toDisplayString(data.evaluateFromCount.pcCount || 0), 1),
                _cache[12] || (_cache[12] = _createElementVNode("img", {
                  class: "qd-code",
                  src: "/images/qd01.png"
                }, null, -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", null, [
                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "qd-type" }, "移动端", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "qd-name" }, "收到评价数", -1)),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _createElementVNode("span", _hoisted_23, _toDisplayString(data.evaluateFromCount.mobileCount || 0), 1),
                _cache[16] || (_cache[16] = _createElementVNode("img", {
                  class: "qd-code",
                  src: "/images/qd01.png"
                }, null, -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", null, [
                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "qd-type" }, "二维码", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "qd-name" }, "收到评价数", -1)),
                _cache[19] || (_cache[19] = _createTextVNode()),
                _createElementVNode("span", _hoisted_24, _toDisplayString(data.evaluateFromCount.ewmCount || 0), 1),
                _cache[20] || (_cache[20] = _createElementVNode("img", {
                  class: "qd-code",
                  src: "/images/qd01.png"
                }, null, -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", null, [
                _cache[21] || (_cache[21] = _createElementVNode("p", { class: "qd-type" }, "政务大厅平板电脑", -1)),
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "qd-name" }, "收到评价数", -1)),
                _cache[23] || (_cache[23] = _createTextVNode()),
                _createElementVNode("span", _hoisted_25, _toDisplayString(data.evaluateFromCount.padCount || 0), 1),
                _cache[24] || (_cache[24] = _createElementVNode("img", {
                  class: "qd-code",
                  src: "/images/qd01.png"
                }, null, -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", null, [
                _cache[25] || (_cache[25] = _createElementVNode("p", { class: "qd-type" }, "微信/支付宝小程序", -1)),
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "qd-name" }, "收到评价数", -1)),
                _cache[27] || (_cache[27] = _createTextVNode()),
                _createElementVNode("span", _hoisted_26, _toDisplayString(data.evaluateFromCount.appletCount || 0), 1),
                _cache[28] || (_cache[28] = _createElementVNode("img", {
                  class: "qd-code",
                  src: "/images/qd01.png"
                }, null, -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", null, [
                _cache[29] || (_cache[29] = _createElementVNode("p", { class: "qd-type" }, "电话邀评", -1)),
                _cache[30] || (_cache[30] = _createElementVNode("span", { class: "qd-name" }, "收到评价数", -1)),
                _cache[31] || (_cache[31] = _createTextVNode()),
                _createElementVNode("span", _hoisted_27, _toDisplayString(data.evaluateFromCount.phoneCount || 0), 1),
                _cache[32] || (_cache[32] = _createElementVNode("img", {
                  class: "qd-code",
                  src: "/images/qd01.png"
                }, null, -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _cache[34] || (_cache[34] = _createStaticVNode("<div class=\"tit\" style=\"margin-top:-15px;\" data-v-0cec37a8><h2 data-v-0cec37a8>本级部门好差评分析</h2><div class=\"title-num\" data-v-0cec37a8>02</div></div><ul class=\"analysis-title\" style=\"text-align:center;\" data-v-0cec37a8><li style=\"width:22%;\" data-v-0cec37a8>部门名称</li><li style=\"width:16%;\" data-v-0cec37a8>评价总量</li><li style=\"width:10%;\" data-v-0cec37a8>非常满意评分</li><li style=\"width:10%;\" data-v-0cec37a8>满意评分</li><li style=\"width:10%;\" data-v-0cec37a8>基本满意评分</li><li style=\"width:10%;\" data-v-0cec37a8>不满意评分</li><li style=\"width:10%;\" data-v-0cec37a8>非常不满意评</li><li style=\"width:10%;\" data-v-0cec37a8>差评率</li></ul>", 2)),
        _createElementVNode("div", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.bmbjsList, (item, index) => {
            return (_openBlock(), _createElementBlock("ul", {
              style: {"text-align":"center"},
              key: index
            }, [
              _createElementVNode("li", {
                style: {"width":"22%","cursor":"text"},
                title: item.deptName
              }, _toDisplayString(item.deptName), 9, _hoisted_30),
              _createElementVNode("li", _hoisted_31, _toDisplayString(item.total), 1),
              _createElementVNode("li", _hoisted_32, _toDisplayString(item.verygoodCount), 1),
              _createElementVNode("li", _hoisted_33, _toDisplayString(item.goodCount), 1),
              _createElementVNode("li", _hoisted_34, _toDisplayString(item.generalgoodCount), 1),
              _createElementVNode("li", _hoisted_35, _toDisplayString(item.notgoodCount), 1),
              _createElementVNode("li", _hoisted_36, _toDisplayString(item.verynotgoodCount), 1),
              _createElementVNode("li", _hoisted_37, _toDisplayString(item.rate) + "%", 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ]))
}
}

})